import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Poi } from './types/Poi';

export default (makeCall: MakeCall) => (poiId: number) =>
  makeCall<Poi>('GET', `/api/v2/poi/${poiId}/commercial`);
